import { snake } from 'change-case'
import { HumanErrorMessages, MaxCheckableNumber } from '../../constants'
import { api } from '../../libs/api'
import { MySet as Set } from '../../libs/polyfill'
import pagination from './pagination'

export default {
  namespaced: true,

  modules: {
    pagination: pagination(),
  },

  state: {
    index: [],
    pageIds: [],
    checkedIds: new Set([]),
    pageCheckedIds: new Set([]),
    detail: {},
    comment: '',
    // 直近の fetchIndex のエラー（成功時は null）。avoidBlank() で使う。
    lastFetchError: null,
  },
  getters: {
    favoredIds: state => new Set(state.index.map(({ id }) => id)),
    favored: (state, getters) => id => getters.favoredIds.has(id),
    checkedCount: state => state.checkedIds.size,
    checked: (_, getters) => getters.checkedCount > 0,
    // eslint-disable-next-line
    pageAllChecked: (state, getters) => getters.checkedCount
      ? !state.pageIds.find(n => !state.pageCheckedIds.has(n))
      : false,
  },
  mutations: {
    comment: (state, value) => state.comment = value,
    updater: (state, value) => state.detail.comment_updater = value.updater,
    index: (state, index) => {
      const pageIds = index.map(({ id }) => id)
      const pageCheckedIds = pageIds.filter(id => state.checkedIds.has(id))

      const newIndex = index.map((startingBusiness) => {
        const newStartingBusiness = Object.assign({}, startingBusiness)
        newStartingBusiness.favored = startingBusiness.in_list
        return newStartingBusiness
      })
      state.index = newIndex
      state.pageIds = pageIds
      state.pageCheckedIds = new Set(pageCheckedIds)
    },
    check: (state, id) => {
      const newCheckedIds = new Set(state.checkedIds)
      const newPageCheckedIds = new Set(state.pageCheckedIds)
      if (Array.isArray(id)) {
        id.forEach((i) => {
          newCheckedIds.add(i)
          newPageCheckedIds.add(i)
        })
      } else {
        newCheckedIds.add(id)
        newPageCheckedIds.add(id)
      }
      state.checkedIds = newCheckedIds
      state.pageCheckedIds = newPageCheckedIds
    },
    uncheck: (state, id) => {
      const newCheckedIds = new Set(state.checkedIds)
      const newPageCheckedIds = new Set(state.pageCheckedIds)
      if (Array.isArray(id)) {
        id.forEach((i) => {
          newCheckedIds.delete(i)
          newPageCheckedIds.delete(i)
        })
      } else {
        newCheckedIds.delete(id)
        newPageCheckedIds.delete(id)
      }

      state.checkedIds = newCheckedIds
      state.pageCheckedIds = newPageCheckedIds
    },
    uncheckAll: (state) => {
      state.checkedIds.clear()
      state.pageCheckedIds.clear()

      state.checkedIds = new Set(state.checkedIds)
      state.pageCheckedIds = new Set(state.pageCheckedIds)
    },
    clearDetail: state => state.detail = {},
    detail: (state, detail) => {
      const newStartingBusinessDetail = Object.assign({}, detail)
      newStartingBusinessDetail.favored = detail.in_list
      state.detail = newStartingBusinessDetail
    },
    favor: (state, { ids, newFavored }) => {
      let newIndex = state.index
      let startingBusinessIds = ids
      if (!Array.isArray(startingBusinessIds)) {
        startingBusinessIds = [startingBusinessIds]
      }
      startingBusinessIds.forEach((startingBusinessId) => {
        newIndex = newIndex.map((s) => {
          if (s.id === startingBusinessId) {
            const newStartingBusiness = Object.assign({}, s)
            newStartingBusiness.favored = newFavored
            return newStartingBusiness
          }
          return s
        })
      })
      state.index = newIndex
    },
    copyCheckedIds: (state, ids) => {
      state.checkedIds = new Set(ids)
    },
    updateStartingBusinessList: (state, list) => {
      state.detail.list = list
    },
    lastFetchError: (state, error) => state.lastFetchError = error,
  },
  actions: {
    toggleCheck ({ commit, dispatch, state: { checkedIds } }, { checked, id }) {
      if (checked && checkedIds.size >= MaxCheckableNumber) {
        dispatch(
          'common/pushToastError',
          { error: HumanErrorMessages.CHECKED_LIMIT },
          { root: true },
        )
        return
      }

      checked
        ? commit('check', id)
        : commit('uncheck', id)
    },
    togglePageCheck (
      { commit, dispatch, getters: { pageAllChecked }, state: { pageIds, checkedIds } },
      { event }) {
      if (!pageAllChecked) {
        const nextCheckedIds = new Set(checkedIds)
        pageIds.forEach((i) => { nextCheckedIds.add(i) })
        if (nextCheckedIds.size > MaxCheckableNumber) {
          dispatch(
            'common/pushToastError',
            { error: HumanErrorMessages.CHECKED_LIMIT },
            { root: true },
          )
          event.preventDefault()
          return
        }
      }
      pageAllChecked
        ? commit('uncheck', pageIds)
        : commit('check', pageIds)
    },
    async fetchIndex ({ commit, dispatch }, query) {
      try {
        const requestParameters = Object.keys(query).reduce((acc, key) => {
          acc[snake(key)] = query[key]
          return acc
        }, {})
        const { meta, index } = await api.fetchStartingBusinesses(requestParameters)
        commit('pagination/newState', meta)
        commit('index', index)
        commit('lastFetchError', null)
      } catch (e) {
        commit('lastFetchError', e)
        const message = (Array.isArray(e) && e[0] && e[0].message) || HumanErrorMessages.SEARCH_FAILED
        dispatch(
          'common/pushToastError',
          { error: { message } },
          { root: true },
        )
        return Promise.reject(e)
      }
    },
    async fetchDetail ({ commit }, { id }) {
      try {
        const response = await api.fetchStartingBusiness(id)
        commit('detail', response[0])
        commit('comment', response[0].comment)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async add ({ commit }, { id, ids }) {
      commit('uncheck', ids || id)
    },
    async remove ({ commit }, { id, ids }) {
      commit('uncheck', ids || id)
    },
    async removeCheckedStartingBusinesses ({ commit }) {
      commit('uncheckAll')
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/startingBusiness.js